import axios from 'axios';

export function submitData(formData) {
  return axios
    .post(`${process.env.GATSBY_CONTENT_API_URL}/contact`, formData, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    })
    .then((res) => res)
    .catch((err) => Promise.reject(err));
}
